import React from 'react';

export default function AboutPage() {
  return (
    <main data-testid="about-page" className="pt-20 min-h-screen">
      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 items-start">
            <div className="md:col-span-5 order-2 md:order-1">
              <div className="aspect-[3/4] overflow-hidden sticky top-28">
                <img
                  src="https://res.cloudinary.com/doaatitvq/image/upload/v1776281996/20260416_0103_Image_Generation_remix_01kp9a469gf3a916gr1fxc3n29_gaztjm.png"
                  alt="About KIRAQ"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="md:col-span-7 order-1 md:order-2">
              <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#C6A978] mb-6">About Us</p>
              <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1E1C1A] mb-10 leading-[1.1]">
                The KIRAQ<br />Philosophy
              </h1>

              <div className="space-y-8 text-base font-light leading-relaxed tracking-wide text-[#7A7369]">
                <p>
                  Founded in the belief that true luxury lies in simplicity, KIRAQ represents a new paradigm in fine jewellery. 
                  We believe the most powerful statement is often the quietest one — a perfectly balanced form, an unexpected texture, 
                  the warm glow of gold against skin.
                </p>
                <p>
                  Every KIRAQ piece begins as a sketch, refined through countless iterations until only the essential remains. 
                  Our artisans, trained in both traditional goldsmithing and contemporary sculpture, bring each design to life 
                  with meticulous attention to proportion, weight, and wearability.
                </p>
                <p>
                  We source our materials with the same intentionality we bring to design. Our gold is recycled and certified, 
                  our pearls are sustainably harvested, and our gemstones are ethically traced from mine to finished piece.
                </p>

                <div className="border-l-2 border-[#C6A978] pl-8 py-4 my-12">
                  <p className="font-['Cormorant_Garamond'] text-2xl font-light text-[#1E1C1A] italic leading-relaxed">
                    "We don't design jewellery to be noticed. We design it to be remembered."
                  </p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#C6A978] mt-4">— The KIRAQ Atelier</p>
                </div>

                <p>
                  Each collection tells its own story. The Pearl Edit celebrates the organic beauty of baroque and freshwater pearls. 
                  The Gold Edit explores bold, sculptural forms in precious metals. After Hours is our evening edit — dramatic, 
                  unapologetic, designed for moments that matter.
                </p>
                <p>
                  At KIRAQ, we believe jewellery should be personal. That's why we offer a bespoke consultation service — 
                  reach out via WhatsApp, and our team will guide you to the piece that speaks to you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
